/**
 * Parses API datetime strings as UTC.
 * Naive MySQL datetimes ("YYYY-MM-DD HH:mm:ss") are treated as UTC wall-clock values.
 */
export function parseApiUtcDateTime(dateStr?: string | null): Date | null {
  if (!dateStr) return null;

  const trimmed = dateStr.trim();
  if (!trimmed) return null;

  if (trimmed.includes('T') || trimmed.endsWith('Z')) {
    const date = new Date(trimmed);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const date = new Date(trimmed.replace(' ', 'T') + 'Z');
  return Number.isNaN(date.getTime()) ? null : date;
}
